(function ($) {

  let ratingBox = $('.js-rating-box');

  if (ratingBox.length) {
    function extractHostname(url) {
      let hostname;
      //find & remove protocol (http, ftp, etc.) and get hostname

      if (url.indexOf("://") > -1) {
        hostname = url.split('/')[2];
      }
      else {
        hostname = url.split('/')[0];
      }

      //find & remove port number
      hostname = hostname.split(':')[0];
      //find & remove "?"
      hostname = hostname.split('?')[0];

      return hostname;
    }

    function getDomainName(url) {
      let domain = extractHostname(url),
        splitArr = domain.split('.'),
        arrLen = splitArr.length;

      //extracting the root domain here
      //if there is a subdomain
      if (arrLen > 2) {
        domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
        //check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
        if (splitArr[arrLen - 2].length == 2 && splitArr[arrLen - 1].length == 2) {
          //this is using a ccTLD
          domain = splitArr[arrLen - 3] + '.' + domain;
        }
      }
      return domain;
    }

    let postId = ratingBox.data('post-id');
    let ratingBoxActions = $('.js-rating-actions');
    let ratingCommentBox = $('.js-rating-comment');
    let ratingBtn = $('.js-btn-rating');
    let ratingBtnComment = $('.js-btn-submit-comment');
    let ratingSuccess = $('.js-rating-success-positive');
    let ratingSuccessComment = $('.js-rating-success-negative');
    let ratingComment = $('#comment');

    function submitRatingData(id, rate, msg) {

      if (id) {

        if (rate === false) {
          rate = 0;
        }

        if (msg === undefined) {
          msg = 0;
        }

        $.ajax({
          type: 'POST',
          url: ratingBox.data('ajax-url'),
          dataType: 'json',
          data: {
            action: 'set_rating',
            id: id,
            rate: rate,
            msg: msg
          },
          beforeSend: function() {
            ratingBox.addClass('preloader');
          },
          success: function (res) {
            let domainName = getDomainName(document.location.hostname);
            let jsCookieValue = 0

            if (res.status === 1) {
              let jsCookie = $.cookie('lv_rating_post_id_' + postId);

              if (jsCookie === undefined) {
                if (res.msg === 1) {
                  ratingBoxActions.removeClass('show');
                  ratingCommentBox.removeClass('show');
                  ratingSuccess.removeClass('show');
                  ratingSuccessComment.addClass('show');
                  jsCookieValue = 2;
                } else {
                  ratingBoxActions.removeClass('show');
                  $('.js-btn-rating[data-rate="-1"]').removeClass('active');
                  ratingCommentBox.removeClass('show');
                  ratingSuccess.addClass('show');
                  jsCookieValue = 1;
                }
                $('#comment').val('');
                ratingBox.removeClass('preloader');

                $.cookie('lv_rating_post_id_' + postId, jsCookieValue, {  expires: 1, path: '/', domain: '.' + domainName, secure: true } );
              }
            }
          },
          complete: function () {

          }
        });
      }
    }

    ratingBtn.on('click', function(e) {
      e.preventDefault();
      let rate = $(this).data('rate');

      if (rate === 1) {
        submitRatingData(postId, rate, 0);
      }

      if (rate === -1) {
        $(this).addClass('active');
        ratingCommentBox.addClass('show');
      }
    });

    ratingBtnComment.on('click', function(e) {
      e.preventDefault();
      let msg = ratingComment.val();
      submitRatingData(postId, -1, msg);
    });
  }
})(jQuery);
